import { ConsultaPadrao } from "../../../components/ConsultaPadrao";
import { model_causa } from "../../../models";

export const Causa = () => {
    const columns = [
        { field: 'cauid', header: 'Código' },
        { field: 'caudescricao', header: 'Descrição' },
        { field: 'cauativo', header: 'Ativo' },
        { field: 'functions', style: { minWidth: '2rem', width: '2rem' } }
    ];

    return (
        <ConsultaPadrao model={model_causa} columns={columns} />
    )
}

